declare global {
  interface Window {
    dataLayer: any[];
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function gtag(...args: any[]) {
  window.dataLayer.push(arguments);
}

const GA_MEASUREMENT_ID = 'G-0FS5MX5P4D';
let ANALYTICS_INITIALIZED = false;

export const initializeAnalytics = () => {
  if (ANALYTICS_INITIALIZED) {
    console.warn('Analytics have already been initialized');
    return;
  }

  window.dataLayer = window.dataLayer || [];

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);

  ANALYTICS_INITIALIZED = true;
};
